import ReactDOM from 'react-dom/client'
import { StrictMode, Suspense, useRef } from 'react'
import { Canvas } from '@react-three/fiber'
import { Loader } from '@react-three/drei'
import { ARButton, XR, Controllers, Hands } from '@react-three/xr'

import Experience from './Experience.jsx'

import './style.css'

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<Render />)

window.addEventListener('wheel', (e) => {
  if (e.ctrlKey) e.preventDefault() //prevent zoom
})

const isMobile = function () {
  return window.matchMedia('(max-width: 767px)').matches
}
let supportsOrientationChange = 'onorientationchange' in window,
  orientationEvent = supportsOrientationChange ? 'orientationchange' : 'resize'
window.addEventListener(
  orientationEvent,
  function () {
    if (isMobile()) document.querySelector('.rotate-phone').style.display = 'block'
    else document.querySelector('.rotate-phone').style.display = 'none'
  },
  false
)

function Render() {
  const videoElement = useRef(null)
  let cameraZ = 2.4

  if (isMobile()) {
    cameraZ = 1.5
  }

  return (
    <StrictMode>
      <Canvas
        camera={{
          fov: 75,
          near: 0.1,
          far: 100,
          position: [2, 1, cameraZ],
        }}
        background={'#000'}
      >
        <XR>
          <Controllers />
          <Hands />
          <Suspense fallback={null}>
            <Experience videoRef={videoElement} />
          </Suspense>
        </XR>
      </Canvas>
      <Loader />

      <ARButton />
      <video ref={videoElement} style={{ display: 'none' }} />
    </StrictMode>
  )
}
